<template>
<div>
  <youtube
    :video-id="videoId"
    ref="youtube"
    :width="800"
    @playing="playing"
    @ready="onReady"
    :player-vars="playerVars">
  </youtube>
</div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    videoId: String,
    startTime: Number,
    muted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      didInitSeek: false,
      playerVars: {
        start: this.startTime || 0,
        hl: 'en', // Keep interface in English
        rel: 0, // Disable related videos
        modestbranding: 1, // Hide YouTube logo
        mute: this.muted ? 1 : 0 // Add mute parameter based on prop
      }
    }
  },
  watch: {
    startTime(newVal) {
      // Reset the init-seek flag so the next play starts from the new time
      // even if the store-side seek raced player readiness.
      this.playerVars.start = newVal || 0;
      this.didInitSeek = false;
    },
    muted(newValue) {
      if (this.player) {
        if (newValue) {
          this.player.mute();
        } else {
          this.player.unMute();
        }
      }
    }
  },
  mounted() {
    this.playerVars.start = this.startTime || 0;
  },
  methods: {
    playAt(time, pauseAfterSeek = false) {
      if (this.player) {
        this.player.seekTo(time);

        if (pauseAfterSeek) {
          this.player.pauseVideo();
        } else {
          this.player.playVideo();
        }
      }
    },
    playing() {
    },
    pause() {
      this.player.pauseVideo();
    },
    resume() {
      if (this.didInitSeek == false) {
        this.player.seekTo(parseFloat(this.startTime));
        this.didInitSeek = true;
      }
      this.player.playVideo();
    },
    onReady() {
      console.log("Player ready event triggered");

      if (this.muted && this.player) {
        try {
          this.player.mute();
        } catch (e) {
          console.warn('Could not mute player:', e);
        }
      }

      this.$emit('ready');
    },
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  },
};
</script>

<style scoped>
.youtube {
  display: flex;
  justify-content: center;
  width: 100%;
}

iframe {
  margin: 0;
  max-width: 100%;
}
</style>
